import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1c62dfc&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=b1c62dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c62dfc",
  null
  
)

export default component.exports